export default __webpack_public_path__ + "static/media/bg-logo.8b8c6954.png";